import { useEffect, useState } from "react";

function diff(saleDate) {
  const ms = saleDate - new Date();
  if (ms <= 0) return null;
  return {
    days: Math.floor(ms / 86400000),
    hours: Math.floor(ms / 3600000) % 24,
    mins: Math.floor(ms / 60000) % 60,
    secs: Math.floor(ms / 1000) % 60,
  };
}

export default function SaleCountdown({ date, eyebrow, sublabel }) {
  const saleDate = new Date(date);
  const [t, setT] = useState(() => diff(saleDate));

  useEffect(() => {
    const id = setInterval(() => setT(diff(saleDate)), 1000);
    return () => clearInterval(id);
  }, [date]);

  if (!t) return null;

  const units = [
    [t.days, "Days"],
    [t.hours, "Hrs"],
    [t.mins, "Min"],
    [t.secs, "Sec"],
  ];

  return (
    <div
      data-testid="sale-countdown"
      className="inline-flex flex-wrap items-center gap-5 md:gap-7 mt-8 px-6 md:px-8 py-4 reveal reveal-delay-3"
      style={{
        background: "rgba(14,44,70,0.55)",
        border: "1px solid rgba(232,215,168,0.45)",
        backdropFilter: "blur(10px)",
        WebkitBackdropFilter: "blur(10px)",
      }}
    >
      <div className="pr-5 md:pr-7" style={{ borderRight: "1px solid rgba(232,215,168,0.3)" }}>
        <div className="eyebrow text-[10px]" style={{ color: "#E8D7A8", letterSpacing: "0.3em" }}>
          {eyebrow}
        </div>
        <div className="font-italic-serif text-lg md:text-xl mt-1" style={{ color: "#FFFFFF" }}>
          {sublabel}
        </div>
      </div>
      {units.map(([n, label]) => (
        <div key={label} className="text-center" data-testid={`countdown-${label.toLowerCase()}`}>
          <div
            className="font-display text-4xl md:text-5xl tabular-nums leading-none"
            style={{ color: "#FFFFFF" }}
          >
            {String(n).padStart(2, "0")}
          </div>
          <div className="eyebrow text-[9px] mt-1.5" style={{ color: "#E8D7A8", letterSpacing: "0.25em" }}>
            {label}
          </div>
        </div>
      ))}
    </div>
  );
}
